import { IconButton } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import { adjustButtonSx } from "./CraneCellAdjustButton";
import { AdjustmentArgs } from "../../types";
import { useCraneDriver } from "../../CraneDriverProvider";

export const CraneCellIncreaseButton = ({
  args,
  disabled,
}: {
  args: AdjustmentArgs;
  disabled?: boolean;
}) => {
  const { incrementMass } = useCraneDriver();
  return (
    <IconButton
      className="material-add-btn"
      onClick={() => {
        incrementMass(args);
      }}
      sx={adjustButtonSx}
      disabled={disabled}
    >
      <AddIcon />
    </IconButton>
  );
};
